import { PropertyDefinitionConfig } from '../types';

/** Pseudo-repository metadata for UI that expects a repository config (e.g. delete dialog title). */
export const QUERY_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idQueryRepository',
	singular: 'Query',
};
